module.exports = __webpack_public_path__ + "static/media/pf_item_32.9b689dd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_32.jpg
// module id = 187
// module chunks = 0